import { getMTCCClient } from '@meitu/xdesign-utils';
import type { IGetMTCCClientOptions } from '@meitu/xdesign-utils/dist/business/getMTCCClient';
import type { Config } from './type';

let __config__: Config = {
    getMtccCommonParams: () => {
        throw new Error('need init options');
    },
    request: () => {
        throw new Error('need init options');
    },
};

export const setConfig = (config: Config) => {
    __config__ = config;
};

export const getConfig = () => {
    return __config__;
};

export const getMTCCClientValue = async (moduleFuncID: string) => {
    const { getMtccCommonParams } = getConfig();

    const commonParams = await getMtccCommonParams();

    // 如果返回的是 string，直接返回
    if (typeof commonParams === 'string') {
        return commonParams;
    }

    const params: IGetMTCCClientOptions = {
        ...commonParams,
        positionInfo: {
            level1: moduleFuncID || commonParams.positionInfo.level1,
        },
    };

    try {
        const value = await getMTCCClient(params);
        return value;
    } catch (err) {
        console.log(err);
        return '';
    }
};

export const getRequestHeaders = async (moduleFuncID?: string, isRemoveAK?: boolean) => {
    const { requestOptions } = getConfig();

    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
        ...(requestOptions?.headers || {}),
    };

    if (moduleFuncID) {
        const mtccClientValue = await getMTCCClientValue(moduleFuncID);
        if (mtccClientValue) {
            headers['x-mtcc-client'] = mtccClientValue;
        }
    }

    if (isRemoveAK) {
        headers['Enterprise-Access-Key-Remover'] = 'true';
    }

    return headers;
};
